var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-currency-field',_vm._g(_vm._b({attrs:{"label":_vm.label,"suffix":"ریال","maxlength":"18","rules":_vm.fieldRules},on:{"keydown":_vm.appendThreeZeros},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'v-currency-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }